import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import useSelectEnnterprise from "../../hooks/useSelectEnnterprise";

export default function SelectEnterprise({ handleSelected, id, color, ...props }) {
	const { optionsSelect } = useSelectEnnterprise()

	return (
		<FormControl size="medium" sx={{ width: "100%" }}>
			<Box sx={{ border: "1px solid #00a7e1", padding: "8px", borderRadius: "4px" }}>
				<Autocomplete
					multiple
					id="tags-readOnly"
					options={optionsSelect}
					onChange={(item, elemento) => {
						handleSelected(elemento);
					}}
					color={color}
					renderInput={(params) => (
						<TextField
							sx={{
								".css-dindiq-MuiInputBase-root-MuiInput-root:before": {
									border: "none"
								}, color: "#00a7e1"
							}}
							{...params}
							variant="standard"
							color={color}
						/>
					)}
					{...props}
					sx={{
						width: { sm: "100%" },
						"div[role='button']": {
							background: '#00a7e1 !important',
							color: "white", 
							textTransform: "capitalize"
						}
					}}
					renderOption={(props, option) => {
						return (
							<li {...props} style={{ textTransform: "capitalize" }} key={option.id}>
								{option.label}
							</li>
						);
					}}
				/>
			</Box>
		</FormControl>
	);
}
